import _Rewards from './model';

export const Rewards = _Rewards;

export default Rewards;



// WEBPACK FOOTER //
// ./data/GroupPerformance/Rewards/index.js